// 用户取，有多个箱格
<template>
  <div class="openBoxList back-index">
    <!-- 流程 -->
    <userFetchFlow :index="2"></userFetchFlow>
    <!-- <div class="box-list clearfix">
      <div
        class="list clearfix"
        v-for="(box, index) in boxList[page-1]"
        :key="index">
        <p class="num">编号：{{box.box_size}}-{{box.box_number}}</p>
        <p
          class="open"
          :class="[box.showStatus ? 'opened' : '']"
          v-html="box.showStatus ? '已打开<span>请取出物品</span>' : '打开'"
          @click="open(box.box_number, box.showStatus)"></p>
      </div>
    </div>

    <div class="paging">
      <el-pagination
        layout="prev, pager, next"
        :current-page.sync="page"
        :page-size="perpage"
        :total="total">
      </el-pagination>
    </div> -->

    <swiper class="box-swiper" :options="swiperOption">
      <swiper-slide v-for="(slide, sIndex) in boxList" :key="sIndex">
        <div class="box-list clearfix">
          <div
            class="list clearfix"
            v-for="(box, index) in slide"
            :key="index">
            <p class="num">编号：{{box.box_size}}-{{box.box_number}}</p>
            <p
              class="open"
              :class="[box.showStatus ? 'opened' : '']"
              v-html="box.showStatus ? '已打开<span>请取出物品</span>' : '打开'"
              @click="open(sIndex, box.box_number, box.showStatus)"></p>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination" v-if="boxList.length != 1"></div>
    </swiper>
    
    <countDown :time="60"></countDown>
  </div>
</template>

<script>
import userFetchFlow from './userFetchFlow'
import countDown from '../common/countDown'
import { cabinetApi } from "../../../../static/turnoverCabinet/js/api.js"
import { showLoading, hideLoading, showToast, storage } from '../../../../static/turnoverCabinet/js/utility'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'openBoxList',
  components: {
    userFetchFlow,
    countDown,
    swiper,
    swiperSlide
  },
  data () {
    return {
      left: '',
      boxList: [],

      page: 1,
      perpage: 4,
      swiperOption: {
        pagination: {
          el: '.swiper-pagination'
        }
      },

    }
  },
  created () {
    this.processList()
    // console.log('this.$route.query.pickupType', this.$route.query.pickupType)
  },
  mounted () {
  },
  methods: {
    processList () {
      let vm = this
      let perpage = vm.perpage
      let boxList = JSON.parse(this.$route.query.boxList)
      let total = boxList.length
      let maxPage = Math.ceil(total / perpage)
      let newBoxList = []
      for(let i=0; i<maxPage; i++) {
        let startI = i*perpage
        let endI = (i==maxPage-1) ? total : (i+1)*perpage
        newBoxList.push([...boxList.slice(startI, endI)])
      }
      vm.total = total
      vm.boxList = [...newBoxList]
    },
    open: async function (sIndex, box_number, showStatus) {
      if (showStatus) {
        return
      }
      let vm = this
      let data = vm.$store.state.fetchData
      data.box_number = box_number
      data.device_no_id = storage.localGetItem('device_no_id')
      
      showLoading('正在打开箱格')
      let res = await cabinetApi.open(data)
      console.log('res', res)
      hideLoading()
      if (res.meta.code === 200) {
        vm.boxList[sIndex].forEach(function (item, i) {
          // showStatus表示箱格状态。false为未打开，true为已打开。
          if (item.box_number === box_number) {
            vm.$set(vm.boxList[sIndex][i], 'showStatus', true)
          }
        })
      } else {
        showToast(res.meta.message)
      }
    }
  }
}
</script>

<style scoped>
.openBoxList{
  width: 100%;
}

.swiper-container {
  padding-bottom: 0.7rem;
}  

.swiper-pagination {
  z-index: 999;
}

.box-list{
  width: 9.62rem;
  margin: 0 auto;
  margin-top: 1rem;
  overflow: hidden;
}

.box-list .list{
  width: 4.56rem;
  height: 1.6rem;
  float: left;
  margin-bottom: 0.5rem;
  border-radius: 0.1rem;
}

.box-list .list:nth-child(odd){
  margin-right: 0.5rem;
}

.box-list .list .num{
  width: 70%;
  font-size: 0.34rem;
  padding-left: 0.3rem;
  border-top-left-radius: 0.1rem;
  border-bottom-left-radius: 0.1rem;
  color: #333333;
  background-color: #ffffff;
}

.box-list .list .num,
.box-list .list .open{
  height: 1.6rem;
  line-height: 1.6rem;
  float: left;
}

.box-list .list .open{
  width:30%;
  color: #ffffff;
  font-size: 0.34rem;
  text-align: center;
  border-top-right-radius: 0.1rem;
  border-bottom-right-radius: 0.1rem;
  background: -webkit-linear-gradient(to top ,#076abf, #4cacff); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(to top,#076abf, #4cacff); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(to top,#076abf, #4cacff); /* Firefox 3.6 - 15 */
  background: linear-gradient(to top,#076abf, #4cacff);
}

.box-list .list .open.opened{
  line-height: 0.34rem;
  background: #3e97df;
  padding-top: 0.45rem;
}

.box-list .list .open.opened >>> span{
  display: block;
  font-size: 0.24rem;
  line-height: 0.24rem;
  margin-top: 0.15rem;
}

.paging {
  text-align: center;
  margin-top: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/turnoverCabinet/userFetch/openBoxList.vue